var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-image"},[_vm._t("content",function(){return [_vm._t("image",function(){return [_c('img',{attrs:{"crossorigin":"anonymous","src":_vm.src}})]}),_vm._t("default")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }